import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@state/auth/auth.state';

/**
 * Blocks access to authenticated routes (the tab bar and everything
 * under it) when no api_id is present in the store. Mirrors the iOS
 * app's startup check in SaltwaterUpDb.isLoggedIn which gates whether
 * the tab bar or the login nav stack is shown.
 */
export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  if (store.selectSnapshot(AuthState.isLoggedIn)) {
    return true;
  }

  router.navigate(['/login']);
  return false;
};

/**
 * Inverse of authGuard: used on the login / register / reset-password
 * pages to bounce an already-authenticated user into the main app rather
 * than showing them the login form again on a reload.
 */
export const noAuthGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  if (store.selectSnapshot(AuthState.isLoggedIn)) {
    router.navigate(['/tabs']);
    return false;
  }

  return true;
};
